module.exports = __webpack_public_path__ + "static/img/qzcc.836b461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/qzcc.png
// module id = 2moS
// module chunks = 93